/**
 * Generated runtime TestId mirror for frontend/src/pages/ServiceAccounts.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ServiceAccountsTestIds = {
  btnCreateEmpty: "btn-create-empty",
  btnCreateServiceAccount: "btn-create-service-account",
  colActiveKeys: "col-active-keys",
  colCreated: "col-created",
  colName: "col-name",
  colStatus: "col-status",
  createDialogTitle: "create-dialog-title",
  createForm: "create-form",
  createInputDescription: "create-input-description",
  createInputName: "create-input-name",
  emptyState: "empty-state",
  serviceAccountsList: "service-accounts-list",
  badgeActiveKeys: (sa_id: string) => `badge-active-keys-${sa_id}`,
  badgeActiveKeysPrefix: () => "badge-active-keys-" as TestIdPrefix,
  badgeStatus: (sa_id: string) => `badge-status-${sa_id}`,
  badgeStatusPrefix: () => "badge-status-" as TestIdPrefix,
  linkServiceAccount: (sa_id: string) => `link-service-account-${sa_id}`,
  linkServiceAccountPrefix: () => "link-service-account-" as TestIdPrefix,
  serviceAccountRow: (sa_id: string) => `service-account-row-${sa_id}`,
  serviceAccountRowPrefix: () => "service-account-row-" as TestIdPrefix
} as const;
